var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginPage"},[_c('SimplePage',{scopedSlots:_vm._u([{key:"widgetFooterLeftPart",fn:function(){return [_c('LoginAsGuest'),_c('SubscriptionButtons')]},proxy:true}])},[_c('Login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }